/**
 * Preferences and Care Configuration
 * Defines the taxonomy for preferences and care requests
 */

export const preferencesAndCareCategories = [
  {
    id: 'preferences',
    name: 'Preferences',
    heading: 'preference',
    items: [
      { id: 'no-parties', name: 'No parties' },
      { id: 'no-smoking', name: 'No smoking' },
    ],
  },
  {
    id: 'care-requests',
    name: 'Care requests',
    heading: 'care request',
    items: [
      { id: 'garden-care', name: 'Garden care' },
      { id: 'houseplant-care', name: 'Houseplant care' },
      { id: 'lawn-care', name: 'Lawn care' },
      { id: 'mail-collection', name: 'Mail collection' },
      { id: 'pet-sitting', name: 'Pet sitting' },
      { id: 'pool-maintenance', name: 'Pool maintenance' },
      { id: 'snow-removal', name: 'Snow removal' },
      { id: 'trash-recycling', name: 'Trash & recycling' },
    ],
  },
];

/**
 * Get category by ID
 */
export const getCategoryById = (categoryId) => {
  return preferencesAndCareCategories.find(cat => cat.id === categoryId);
};

/**
 * Get item by category ID and item ID
 */
export const getItemByIds = (categoryId, itemId) => {
  const category = getCategoryById(categoryId);
  if (!category) return null;
  return category.items.find(item => item.id === itemId);
};

/**
 * Get all items for a category sorted A-Z
 */
export const getCategoryItems = (categoryId) => {
  const category = getCategoryById(categoryId);
  if (!category) return [];
  return [...category.items].sort((a, b) => a.name.localeCompare(b.name));
};

/**
 * Check if category has custom items support
 */
export const categorySupportsCustom = (categoryId) => {
  return categoryId === 'preferences' || categoryId === 'care-requests';
};
